<template>
    <div class="meeting-list">
        <div class="list-tittle">
            <div class="tittle-left">
                <span class="list" >会议中心</span>
                <span v-if="commonUserFlag && (videoMeeting == 1)" @click="initiateMeeting" class="lauch-list">发起会议</span>
            </div>
            <div v-if="commonUserFlag" class="tittle-right">
                <span class="status-select">
                    <el-select v-model="status" placeholder="请选择" @change = "changeSlect">
                        <el-option
                        v-for="item in statusOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </span>
                <span class="type-select">
                    <el-select v-model="meetingType" placeholder="请选择">
                        <el-option
                        v-for="item in typeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </span>
                <span v-if="commonUserFlag" class="org-select">
                    <el-select v-model='orgList' placeholder="请选择">
                        <el-option
                        v-for="item in orgOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </span>
                <span @click="seachList()" class="search-list">搜索</span>
                <!-- <span @click="goCustomer" class="search-list">普通用户</span> -->
            </div>
        </div>
        <div class="content">
            <div class="item_body">
                <el-table
                    :data="meetingList"
                    cell-class-name = "cell-name"
                    header-cell-class-name = 'cell-name'
                    style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="会议主题">
                    </el-table-column>
                    <el-table-column
                        prop="orderTime"
                        :formatter="formatDate"
                        label="开始时间">
                    </el-table-column>
                    <el-table-column
                        prop="meetingTypeName"
                        label="会议类型">
                    </el-table-column>
                    <el-table-column
                        prop="orgName"
                        label="发起方">
                    </el-table-column>
                    <el-table-column
                        prop="mediationStatus"
                        :formatter="formatStatus"
                        label="状态">
                    </el-table-column>
                    <el-table-column
                        min-width ='110'
                        label="操作"
                        >
                        <template slot-scope="scope">
                            <el-button  class="btn-action" @click="checkDetail(scope.row)" type="text" size="small">查看详情</el-button>
                            <el-button v-if =  "scope.row.mediationStatus == 'INIT' && scope.row.cancelFlag" class="btn-action" @click="concelMeeting(scope.row)" type="text" size="small">取消会议</el-button>
                            <el-button  v-if =  "(scope.row.mediationStatus == 'RUNNING' || scope.row.mediationStatus == 'END') && commonUserFlag"  class="btn-action" @click="openvideodialog(scope.row.id)" type="text" size="small">视频记录</el-button>
                            <el-button v-if =  "scope.row.mediationStatus == 'RUNNING'"  class="btn-action" @click="enterVedio(scope.row)" type="text" size="small">进入视频</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="page-box" v-if= 'totalData'>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalData"
                :current-page.sync="curIndex"
                :page-size="pageSize"
                @current-change="changepage"
                prev-text="上一页"
                next-text="下一页">
            </el-pagination>
        </div>
        <video-record ref="comVideoRecord"></video-record>
        <!-- <dialog-case ref="dialogStatus"></dialog-case> -->
    </div>
</template>
<script>
import videoRecord from '@/components/videoRecord'
// import dialogCase from '@/views/meetingList/components/dialogCase'
import {queryMeetingList,searchDictionaryInfo,cancelMediationMeeting,queryLitigantMeetingList} from '@/api/meeting'
import {ERR_OK} from '@/api/reConfig'
import {dateformat,setStore, getUrlParams, getStore, removeStore, getStoreSession } from '@/utils/utils.js'

export default {
    data() {
        return {
            curIndex:1,
            pageSize:10,
            totalData:0,
            status:'ALL',
            meetingType:"ALL",
            orgList:null,
            statusOptions: [{
                value: 'ALL',
                label: '所有状态'
                },{
                value: 'INIT',
                label: '未开始'
                }, {
                value: 'RUNNING',
                label: '进行中'
                },
                {
                value: 'END',
                label: '已结束'
                }
            ],
            typeOptions: [{
                value: 'ALL',
                label: '所有会议'
                },{
                value: 'MEETING_ONLINE',
                label: '磋商会议'
                },{
                value: 'MEETING_JOINT',
                label: '联席会议'
                }
            ],
            orgOptions: [{
                value: null,
                label: '所有机构'
                }
            ],
            meetingList: [],
            cancelFlag : false,
            loginInfo:{},
            loginInfouser:{},
            commonUserFlag:true,
            currentLoginUserId: null,
            videoMeeting: 1,
            caseId: null,
        }
    },
    watch: {
        'orgOptions': function (newData, oldData) {
            this.orgList = newData[0].value
        },
    },
    created() {
        if(getUrlParams().appName){
            setStore('appName', getUrlParams().appName);
        }
        if(getStore('loginInfo')){
            this.loginInfo = JSON.parse(getStore('loginInfo'))
            this.currentLoginUserId = this.loginInfo.userInfo.userId
        }else {
            this.loginInfouser = JSON.parse(getStore('loginInfouser'))
            // this.commonUserFlag = false
        }
    },
    components:{
        videoRecord,
        // dialogCase
    },
    mounted() {
        this.videoMeeting = getUrlParams().videoMeeting ? getUrlParams().videoMeeting : this.videoMeeting
        this.caseId = getUrlParams().caseId ? getUrlParams().caseId : this.caseId
        if(getUrlParams().token) {
            setStore('isOutter', 1);   
            setStore('flk', getUrlParams().token);   
            document.querySelector('.el-header').style.display = 'none'
            document.querySelector('.el-aside').style.display = 'none'
        }    
        // console.log('token',getUrlParams().token)
        this.searchDictionaryInfo()
        this.seachList()
    },
    methods: {
        formatDate (mtime) {
            if (!mtime.orderTime) { return; }
            let date = new Date(mtime.orderTime);
            return dateformat(date, 'yyyy-MM-dd hh:mm');
        },
        formatStatus(status){
            if (!status.mediationStatus) { return; }
            let statusName = ''
            switch (status.mediationStatus) {
                case 'INIT':
                    statusName = '未开始'
                    break;
                case 'RUNNING':
                    statusName = '进行中'
                    break;
                case 'END':
                    statusName = '已结束'
                    break;
                case 'END_CANCEL':
                    statusName = '已结束'
                    break;    
                default:
            }
            return statusName
        },
        //进入视频
        enterVedio(params){
            // console.log(this.commonUserFlag, this.currentLoginUserId===params.creatorId)
            // this.$refs.dialogStatus.openDialog(params,this.commonUserFlag,this.currentLoginUserId)
            if(this.commonUserFlag&&this.currentLoginUserId===params.creatorId){
                this.$router.push({
                    path: '/meeting/mediator', 
                    query: { 
                        roomid: params.roomId,
                        caseid: params.caseId,
                        meetingid:params.id,
                    }
                })
            } else {
                this.$router.push({
                    path: '/meeting/member', 
                    query: { 
                        roomid: params.roomId,
                        caseid:params.caseId,
                        meetingid:params.id,
                    }
                })
            }
        },
        goCustomer(){
            this.$router.push({
                path: '/meeting/member', 
                query: { 
                    roomid: 'aact4A',
                    caseid:"",
                    meetingid:13
                }
            })
        },
        //获取机构
        searchDictionaryInfo(){
            searchDictionaryInfo({
                parentCode: "ORGANIZATION_TYPE"
            }).then(res =>{
                if(res.data.code == ERR_OK){
                    let dataList = res.data.data
                    if(dataList && dataList.length){
                        dataList.forEach(element => {
                            let options = {
                                value: element.code,
                                label: element.value
                            }
                            this.orgOptions.push(options)
                        });
                    }
                }
            },erro => {
                console.log(erro)
            })
        },
        seachList(page){
            !page&&(this.curIndex=1)
            let params = {
                    meetingStatus: this.status,
                    meetingType:this.meetingType ,
                    orgCode:this.orgList,
                    pageIndex:this.curIndex,
                    pageSize:this.pageSize,
                    caseId: this.caseId,
                }
            if(this.commonUserFlag){
                queryMeetingList(params).then(res =>{
                    if(res.data.code == ERR_OK){
                        let tempDataList = [],dataList = res.data.data
                        if(dataList.list && dataList.list.length>0){
                            dataList.list.forEach(element => {
                                let mtimeFlag
                                if (!element.orderTime) { return; }
                                let minutesPlus = (element.orderTime - new Date().getTime())/60000
                                if(minutesPlus>30){
                                    mtimeFlag = true
                                } else{
                                    mtimeFlag = false
                                }
                                let options = {
                                    creatorId: element.creatorId,
                                    caseId: element.caseId,
                                    id: element.id,
                                    mediationStatus: element.mediationStatus,
                                    meetingType: element.meetingType,
                                    meetingTypeName: element.meetingTypeName,
                                    name: element.name,
                                    orderTime: element.orderTime,
                                    orgId: element.orgId,
                                    orgName: element.orgName,
                                    roomId: element.roomId,
                                    startTime:element.startTime,
                                    cancelFlag:mtimeFlag
                                }
                                tempDataList.push(options)
                            })
                        }
                        this.meetingList = tempDataList
                        this.totalData = dataList.totalRows
                    }
                },erro => {
                    console.log(erro)
                })
            } else {
                queryLitigantMeetingList(params).then(res =>{
                    if(res.data.code == ERR_OK){
                        let dataList = res.data.data
                        this.meetingList = dataList.list
                        this.totalData = dataList.totalRows
                    }
                },erro => {
                    console.log(erro)
                })
            }
        },
        openvideodialog(meetingid) {
            this.$refs.comVideoRecord.openDialog( meetingid)
        },
        //发起会议
        initiateMeeting(){
            this.$router.push({
                path: '/meeting/reservateMeeting',
                query:{
                    caseDetailFlag:false,
                    id: this.caseId
                }
            });
        },
        
        checkDetail(row){

            this.$router.push({
                path: '/meeting/meetingDetail',
                query:{
                    caseId:row.caseId,
                    meetingId:row.id,
                }
            });
        },
        changepage(value) {
            this.curIndex = value
            this.seachList(1)
        },
        changeSlect(value) {
            console.log(value)
        },
        concelMeeting(param) {
            this.$alert(`<div>你是否确认取消${param.name}会议</div>`, '温馨提示', {
                dangerouslyUseHTMLString: true,
                showCancelButton: true,
                confirmButtonText: '确定',
                confirmButtonClass: 'book_button_primary_small',
                cancelButtonClass: 'book_button_default_small',
                cancelButtonText: '取消',
                customClass: 'book_quit'
            }).then(() => {
                //new Date(mtime.orderTime);new Date().getTime()
                let datePlus = (element.orderTime - new Date().getTime())/60000
                if(datePlus<30 && datePlus>0){
                    this.$alert(`<div>您预约的${param.name}会议，距离会议开始时间已经不足30分钟，您无法取消。</div>`, '温馨提示', {
                        dangerouslyUseHTMLString: true,
                        showCancelButton: true,
                        confirmButtonText: '确定',
                        confirmButtonClass: 'book_button_primary_small',
                        cancelButtonClass: 'book_button_default_small',
                        cancelButtonText: '取消',
                        customClass: 'book_quit'
                    }).then(() => {
                         
                    })
                } else {
                    cancelMediationMeeting({
                            meetingId:param.id
                        }).then((res) => {
                            this.seachList()
                        })
                }
            })
        }
    }
}
</script>
<style lang="scss">
.el-message-box__wrapper{
    .el-message-box.book_quit{
        width: 440px;
        text-align: center;
        position: relative;
        .el-message-box__header{
            border-bottom: 1px solid #e5e5e5;
            padding: 20px 35px 10px;
            font-size: 16px;
            color:#666;
            text-align: left;
            padding-left: 40px;
            &:before {
                content: '';
                position: absolute;
                display: inline-block;
                left: 26px;
                top: 18px;
                width: 4px;
                height: 20px;
                background: #0083c8;
            }
        }
        .el-message-box__btns{
            text-align: center;
            .book_button_primary_small{
                color:  #fff;
                margin-left: 30px;
            }
            .book_button_default_small {
                background: #fff;
                color:  #0083c8;
            }
            .el-button {
                width: 150px;
                height: 50px;
            }
        }
        // .el-message-box__content{
        //     padding: 60px 0 50px 0;
        //     font-size: 16px;
            
        // }
    }
}
.meeting-list {
    .list-tittle {
        width: 100%;
        height: 60px;
        background: #fff;
        overflow: hidden;
        line-height: 60px;
        .tittle-left{
            .lauch-list {
                cursor: pointer;
                font-size: 14px;
                display: inline-block;
                border-radius: 4px;
                margin-left: 20px;
                width: 80px;
                height: 30px;
                line-height: 30px;
                border: 1px solid #0083c8;
                color:#0083c8;
                text-align: center;
                &:hover{
                    color: #fff;
                    background: #0083c8;
                }
            }
            float: left;
            margin-left: 30px;
            font-size: 16px;
            color: #333333;
            .list {
                display: inline-block;
                margin-right: 20px;
            }
            .el-button {
                height: 30px;
                width: 96px;
                line-height: 5px;
                border-radius: 4px;
                border: solid 1px #0083c8;
                color: #0083c8;
                &:hover{
                    color: #fff;
                    background: #0083c8;
                }
            }
            
        }
        .tittle-right {
            float: right;
            margin-right: 20px;
            .status-select {

            }
            .type-select{
                margin: 0 20px 0 20px;

            }
            .org-select{
                
            }
            .search-list{
                cursor: pointer;
                font-size: 14px;
                display: inline-block;
                border-radius: 4px;
                margin-left: 20px;
                width: 80px;
                height: 30px;
                line-height: 30px;
                border: 1px solid #0083c8;
                color:#0083c8;
                text-align: center;
                &:hover{
                    color: #fff;
                    background: #0083c8;
                }
            }
        }
    }
    .item_body {
        margin-top: 10px;
        .cell-name {
            text-align: center;
        }
        .btn-action {
            font-size: 14px;
        }

    }
    .page-box {
        background: #fff;
        text-align: center;
        padding: 40px 0 40px;
        li {
            padding: 0;
            border: none;
        }
    }

}

</style>
